import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    Button,
    FormControl,
    Select,
    MenuItem,
    Box,
    CardMedia,
    Tabs,
    Tab,
    createTheme,
} from '@mui/material';
import Footer from '../navbar/Footer';
import moment from 'moment';

const annuaires = [
  {
      title: "Rapport de l'enquête sur le Commerce Transfrontalier Informel au Burundi, édition 2023 (ECTIB-2023) ",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-annuel-_ECTIB-2023_VERSION-FINALE_29.03.pdf",
      description: "En 2023, les échanges transfrontaliers informels du Burundi ont totalisé 349 milliards BIF, dominés par les importations (235 milliards) provenant à 98,5% de Tanzanie, tandis que les exportations (114 milliards) concernaient principalement la Tanzanie (63,9%) et la RDC (35,3%), transitant surtout par six provinces clés.",
      date: "2023-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport de l’Enquête sur le Commerce Transfrontalier Informel au Burundi, édition 2020 (ECTIB-2020)",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-Annuel-ECTIB-2020_05.05.pdf",
      description: "En 2020, les échanges transfrontaliers informels du Burundi ont atteint 65 milliards BIF en 7 mois, avec des importations (42 milliards) dominées par les bovins et des exportations (23 milliards) axées sur les boissons et savons, concentrées à 90% dans les provinces de Makamba et Cankuzo, et majoritairement menées par des hommes (95,7%).",
      date: "2020-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport de l’Enquête sur les Marges de Commerce et de Transport 2019",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-de-lEnquete-de-Structure-sur-les-Marges-Commerciales-et-de-Transport-Vf.pdf",
      description: "L'étude révèle des marges commerciales élevées au Burundi, avec 60% des produits dépassant 10% de marge nette, atteignant jusqu'à 110,4% pour le sable et 79% pour les peaux de bétail, soulignant la forte rentabilité du secteur.",
      date: "2019-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport annuel de 2019 sur le Commerce Extérieur de Marchandises au Burundi",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-annuel-2019-sur-CE-de-marchandises_VF-apres-CTIS_16.12.pdf",
      description: "Entre 2015 et 2019, les importations du Burundi ont bondi à 1 638,4 milliards BIF, creusant le déficit commercial à 1 304,6 milliards, malgré la croissance des exportations d'or, tandis que le gasoil et les médicaments dominaient les importations, avec les Émirats Arabes Unis et la RDC comme principaux partenaires.",
      date: "2019-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport de l’Enquête sur le Commerce Transfrontalier Informel au Burundi, édition 2019 (ECTIB-2019)",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-Annuel-ECTIB-2019.pdf",
      description: "En 2019, les échanges transfrontaliers informels ont totalisé 134,7 milliards BIF, avec un excédent commercial (74,7 milliards en exportations, 59,9 milliards en importations), dominés par les bovins et arachides à l'import et les boissons à l'export, principalement concentrés à Bujumbura et Makamba, avec une forte prédominance masculine.",
      date: "2019-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport d'enquête sur les Coûts de la Production de la Pêche au Burundi 2019",
      link: "/documents/EnqueteCommerceTransportEntreprises/RAPPORT-DE-LENQUETE-DE-DETERMINATION-DES-COUTS-DE-PRODUCTION-DE-LA-PECHE-Vf.pdf",
      description: "L'étude analyse les coûts de production dans la pêche burundaise, interrogeant 585 acteurs du secteur pour établir un profil économique complet et mesurer son impact sur le PIB national.",
      date: "2019-10-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport de l’Enquête sur le Commerce Transfrontalier Informel au Burundi (ECTIB-2018)",
      link: "/documents/EnqueteCommerceTransportEntreprises/ECTIB-2018_Rapport-Final.pdf",
      description: "En 2018, les échanges transfrontaliers informels du Burundi ont totalisé 92,8 milliards BIF, marqués par une forte dépendance à la RDC et la Tanzanie, avec les bovins comme principale importation et les bières en tête des exportations, dans un secteur dominé par les hommes.",
      date: "2018-10-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport annuel de 2018 sur le Commerce Extérieur de Marchandises",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-annuel-2018-sur-CE-de-marchandises-.pdf",
      description: "En 2018, les exportations burundaises ont progressé à 321,3 milliards BIF (or, café, thé), malgré un déficit commercial croissant, avec des importations dominées par les produits pétroliers et pharmaceutiques, les Émirats Arabes Unis et la RDC restant les principaux partenaires.",
      date: "2018-10-01",
      image: 'assets/covers/cover4.PNG', 
  },
];
const odd = [
  {
      title: "Rapport Provisoire d’Enquête Légère de Transport Rémunéré au Burundi, Édition 2018 : Volet Formel et Informel",
      link: "/documents/EnqueteCommerceTransportEntreprises/RAPPORT-D-ENQUETE-DE-STRUCTURE-SUR-LE-TRANSPORT-FORMEL-ET-INFORMEL-Vf.pdf",
      description: "L'étude révèle que 50% des entreprises de transport burundaises œuvrent dans la manutention, avec 95% appartenant au privé (chiffre d'affaires >49 milliards BIF), tandis que 89% des employés sont déclarés, particulièrement dans les services postaux et le fret routier.",
      date: "2018-10-01",
      image: 'assets/covers/cover4.PNG', 
  },
  {
      title: "Rapport Définitif de l'enquête de Base pour le Suivi-Évaluation des Impacts Socioéconomiques du Projet d’Aménagement de la Route Nationale n° 3, Tronçon : Mugina-Mabanda-Nyanza-Lac (45km) et de 7 Ponts Piétonniers Suspendus (PPS)",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport_Definitif_Etude-Impacts-Socio-Economiques-Bitumage-Route-Mugina_Mabanda_Nyanza-Lac.pdf",
      description: "L'étude révèle que le projet RN3 est perçu positivement par 99,2% des ménages riverains, majoritairement agricoles (83,2%), avec un revenu moyen de 625 000 BIF/an, malgré des défis persistants en matière d'habitat, d'énergie et d'accès à l'eau.",
      date: "2018-10-01",
      image: 'assets/covers/cover4.PNG', 
  },
];
const entreprises = [
  {
      title: "Rapport de l’Enquête sur les Investissements Directs Étrangers au Burundi « EIDEB, Édition 2013 »",
      link: "/documents/EnqueteCommerceTransportEntreprises/Rapport-final_EIDEB2013-final-en-PDF-1.pdf",
      description: "L'enquête révèle que les IDE au Burundi (177,2 milliards BIF en 2012) sont concentrés dans les transports (72 millions USD), dominés par l'Île Maurice (51,5%) et le Kenya (14,1%), générant 9 731 emplois, bien que les secteurs moins financés (agroalimentaire, construction) contribuent à 48% du chiffre d'affaires total (549 millions USD).",
      date: "2013-01-01",
      image: 'assets/covers/cover4.PNG', 
  },
];


const theme = createTheme({
    palette: {
      primary: { main: '#388E3C' },
      secondary: { main: '#673AB7' },
      background: { default: '#f5f5f5' },
    }  
});

function EnqueteCommerceTransportEntreprise() {
    const [activeTab, setActiveTab] = useState(0);
    const [entreprisesYear, setEntreprisesYear] = useState('');
    const [healthYear, setHealthYear] = useState('');
    const [demographyYear, setDemographyYear] = useState('');
    const [allYears, setAllYears] = useState([]);
    const [healthReportsCount, setHealthReportsCount] = useState(2);
    const [demographyReportsCount, setDemographyReportsCount] = useState(2);
    const [entreprisesReportsCount, setEntreprisesReportsCount] = useState(2);

    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        const healthYears = [...new Set(annuaires.map(item => new Date(item.date).getFullYear()))];
        const demographyYears = [...new Set(odd.map(item => new Date(item.date).getFullYear()))];
        const enterprisesYears = [...new Set(entreprises.map(item => new Date(item.date).getFullYear()))];

        const uniqueYears = [...new Set([...healthYears, ...demographyYears, ...enterprisesYears])];
        uniqueYears.sort((a, b) => b - a);
        setAllYears(uniqueYears);
    }, []);

    const filteredHealthReports = React.useMemo(() => {
        return healthYear
            ? annuaires.filter(annuaire => new Date(annuaire.date).getFullYear().toString() === healthYear)
            : annuaires;
    }, [healthYear]);

    const filteredDemographyReports = React.useMemo(() => {
        return demographyYear
            ? odd.filter(document => new Date(document.date).getFullYear().toString() === demographyYear)
            : odd;
    }, [demographyYear]);

    const filteredEntreprisesReports = React.useMemo(() => {
        return entreprisesYear
            ? entreprises.filter(document => new Date(document.date).getFullYear().toString() === entreprisesYear)
            : entreprises;
    }, [entreprisesYear]);

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px', paddingInline: '20px' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChangeTab}
                    textColor="inherit"
                    indicatorColor="secondary"
                >
                    <Tab label="Commerce" />
                    <Tab label="Transport" />
                    <Tab label="Entreprises" />
                </Tabs>

                {/* Section Commerce */}
                {activeTab === 0 && (
                    <>
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                            Commerce
                        </Typography>
                        <Typography variant="body1" align="justify" paragraph>
                            Cette section présente les rapports d'enquête sur le commerce transfrontalier informel au Burundi. Ces documents fournissent une analyse détaillée des volumes d'échanges, des produits concernés et des principales tendances commerciales, offrant ainsi une vision approfondie des dynamiques économiques qui influencent le secteur commercial dans le pays.
                        </Typography>
                        <FormControl variant="outlined" fullWidth  style={{ marginLeft: '0px', width: '300px', marginBottom: 20  }}>
                            <Select
                                value={healthYear}
                                onChange={(e) => setHealthYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Toutes les rapports</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            {filteredHealthReports.slice(0, healthReportsCount).map((bulletin, index) => (
                                <Grid item xs={12} sm={6} md={12} key={index}>
                                    <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <Box sx={{ display: 'flex' }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                                                image={bulletin.image}
                                                alt={bulletin.title}
                                                onClick={() => window.open(bulletin.link, '_blank')} 
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                                <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#388E3C' }}>
                                                    <a
                                                        href={bulletin.link}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {<DownloadIcon />}{bulletin.title}
                                                    </a>
                                                </Typography>
                                                <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                    {bulletin.description}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {moment(bulletin.date).format('MMMM YYYY')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        <Button 
                            onClick={() => setHealthReportsCount(healthReportsCount + 2)}
                            style={{
                              marginTop: '20px',
                              marginBottom: '20px',
                              backgroundColor: theme.palette.primary.main,
                              color: 'white',
                            }}
                        >
                            Plus de rapports
                        </Button>
                    </>
                )}

                {/* Section Transport */}
                {activeTab === 1 && (
                    <>
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                            Transport
                        </Typography>
                        <Typography variant="body1" align="justify" paragraph>
                            Cette section présente les rapports d'enquête relatifs au secteur des transports au Burundi. Ces documents mettent en lumière les différents modes de transport (formels et informels), leur impact sur l'économie locale, et les défis auxquels le secteur est confronté. Ils permettent de mieux comprendre le rôle crucial des infrastructures de transport dans le développement économique du pays.
                        </Typography>
                        <FormControl variant="outlined" fullWidth  style={{ marginLeft: '0px', width: '300px', marginBottom: 20  }}>
                            <Select
                                value={demographyYear}
                                onChange={(e) => setDemographyYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Toutes les rapports</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            {filteredDemographyReports.slice(0, demographyReportsCount).map((bulletin, index) => (
                                <Grid item xs={12} sm={6} md={12} key={index}>
                                    <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <Box sx={{ display: 'flex' }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                                                image={bulletin.image}
                                                alt={bulletin.title}
                                                onClick={() => window.open(bulletin.link, '_blank')} 
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                                <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#388E3C' }}>
                                                    <a
                                                        href={bulletin.link}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {<DownloadIcon />}{bulletin.title}
                                                    </a>
                                                </Typography>
                                                <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                    {bulletin.description}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    Publié en {moment(bulletin.date).format('MMMM YYYY')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        <Button 
                            onClick={() => setDemographyReportsCount(demographyReportsCount + 2)}
                            style={{
                              marginTop: '20px',
                              marginBottom: '20px',
                              backgroundColor: theme.palette.primary.main,
                              color: 'white',
                            }}
                        >
                            Plus de rapports
                        </Button>
                    </>
                )}

                {/* Section Entreprises */}
                {activeTab === 2 && (
                    <>
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                            Entreprises
                        </Typography>
                        <Typography variant="body1" align="justify" paragraph>
                            Cette section présente les rapports d'enquête sur les entreprises, mettant en avant les investissements directs étrangers, les statistiques sur les entreprises et d'autres études économiques pertinentes. Ces rapports sont conçus pour fournir des informations précieuses aux investisseurs et aux décideurs, facilitant ainsi une meilleure compréhension des opportunités d'affaires et des défis rencontrés dans le tissu économique burundais.
                        </Typography>
                        <FormControl variant="outlined" fullWidth  style={{ marginLeft: '0px', width: '300px', marginBottom: 20  }}>
                            <Select
                                value={entreprisesYear}
                                onChange={(e) => setEntreprisesYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Toutes les rapports</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            {filteredEntreprisesReports.slice(0, entreprisesReportsCount).map((document, index) => (
                                <Grid item xs={12} sm={6} md={12} key={index}>
                                    <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <Box sx={{ display: 'flex' }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                                                image={document.image}
                                                alt={document.title}
                                                onClick={() => window.open(document.link, '_blank')} 
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                                <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#388E3C' }}>
                                                    <a
                                                        href={document.link}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {<DownloadIcon />}{document.title}
                                                    </a>
                                                </Typography>
                                                <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                    {document.description}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    Publié en {moment(document.date).format('MMMM YYYY')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        <Button 
                            onClick={() => setEntreprisesReportsCount(entreprisesReportsCount + 2)}
                            style={{
                              marginTop: '20px',
                              backgroundColor: theme.palette.primary.main,
                              color: 'white',
                            }}
                        >
                            Plus de rapports
                        </Button>
                    </>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
}

export default EnqueteCommerceTransportEntreprise;